import React from "react";
import constants from "constants/constants";
import { PARTNER_TRACK_CONSTANTS } from "./PartnerTrackBanner.constants";
import { CheckIcon } from "./CheckIcon";

export const PartnerTrackBanner = () => {
  const { TITLE, DESCRIPTION, BUTTON_TEXT, PERKS } = PARTNER_TRACK_CONSTANTS;

  const buttonLink =
    constants.referral_link || PARTNER_TRACK_CONSTANTS.BUTTON_LINK;

  return (
    <div className="tw-relative tw-overflow-hidden tw-rounded-[20px] tw-bg-[linear-gradient(115deg,#2A2568_0%,#4338CA_100%)] tw-text-white tw-p-[clamp(32px,5vw,48px)] tw-mb-16">
      {/* Top Section: Content + Perks */}
      <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-8 tw-items-center">
        {/* Left Column: Heading, description, CTA */}
        <div className="lg:tw-col-span-7">
          <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-bold tw-leading-tight tw-tracking-tight tw-text-white tw-mb-3">
            {TITLE}
          </h2>

          <p className="tw-text-sm sm:tw-text-base tw-leading-relaxed tw-text-white/80 tw-font-normal tw-max-w-xl">
            {DESCRIPTION}
          </p>

          <div className="tw-mt-6">
            <a
              href={buttonLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tw-inline-flex tw-items-center tw-justify-center tw-bg-white tw-text-[#392EAA] tw-font-bold tw-text-sm tw-px-6 tw-py-3 tw-rounded-xl tw-shadow-sm hover:tw-bg-gray-50 hover:tw-text-[#2e2494] tw-transition-colors tw-no-underline"
            >
              {BUTTON_TEXT}
            </a>
          </div>
        </div>

        {/* Right Column: Perks Checklist */}
        <div className="lg:tw-col-span-5 lg:tw-pl-4 tw-text-[14px]">
          <ul className="tw-list-none tw-p-0 tw-m-0 tw-space-y-3">
            {PERKS.map((perk) => (
              <li
                key={perk.ID}
                className="tw-flex tw-items-start tw-gap-3 tw-text-white/90"
              >
                <CheckIcon />
                <span className="tw-leading-normal">{perk.TEXT}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
